import { render, staticRenderFns } from "./mzDrugZJDetail.vue?vue&type=template&id=6a5ef072&scoped=true"
import script from "./mzDrugZJDetail.vue?vue&type=script&lang=js"
export * from "./mzDrugZJDetail.vue?vue&type=script&lang=js"
import style0 from "./mzDrugZJDetail.vue?vue&type=style&index=0&id=6a5ef072&prod&scoped=true&lang=css"
import style1 from "./mzDrugZJDetail.vue?vue&type=style&index=1&id=6a5ef072&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a5ef072",
  null
  
)

export default component.exports